import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 252574CE-020B-461A-995B-D4BA81741BBC
 * name format-paragraph
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-paragraph.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatParagraphIcon = createSvgIcon(<><path d="M13,4A4,4 0 0,1 17,8A4,4 0 0,1 13,12H11V18H9V4H13M13,10A2,2 0 0,0 15,8A2,2 0 0,0 13,6H11V10H13Z" /></>, 'FormatParagraphIcon');
export default FormatParagraphIcon